<script lang="ts">
  import { i18n } from '../../util/i18n/i18n';
</script>

<h1>
  <picture>
    <source srcset="logo.avif" type="image/avif" />
    <source srcset="logo.png" type="image/png" />
    <img
      class="logo"
      src="logo.png"
      width={362}
      height={320}
      alt={i18n('poll.logo-for', { values: { eventname: 'Stjernekamp' } })}
    />
  </picture>
</h1>

<style>
  :global(#index-logo) {
    display: none !important;
  }
  img {
    margin-top: -2rem;
  }

  h1 {
    padding: 0;
  }

  .logo {
    max-height: 20rem;
  }
</style>
